module.exports = __webpack_public_path__ + "static/media/lets_read_logo.9eb044fd.png";